<template>
  <div class="home-box">
    <!-- 头部 -->
    <Header :current="current" :scrollTop="scrollTop"></Header>

    <div class="swiperHeader">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in $t('header.title') == '中鑫新材' ? headList : headList1"
          :key="index">
          <img :src="item.img" alt="" @click="toPath(item)">
        </div>
      </div>
      <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-pagination"></div><!--分页器。如果放置在swiper外面，需要自定义样式。-->
    </div>

    <!-- 公司介绍 -->
    <div class="home-content">
      <div class="company-sg">
        <div class="sg-style">{{ $t('home.content.title') }}</div>
        <div class="line"></div>
        <div class="company-info">
          {{ $t('home.content.info1') }}
        </div>
        <div class="company-info">
          {{ $t('home.content.info2') }}
        </div>
           <div class="company-info">
          {{ $t('home.content.info3') }}
        </div>
        <!--        <div class="company-info">-->
        <!--          公司在智慧农业终端研发基地的建设与发展方面展现出了卓越的实力。该研发基地汇聚了一批顶尖的技术人才，他们具备丰富的行业经验和专业知识，专注于智慧农业终端的研发与创新。-->
        <!--        </div>-->
        <!--        <div class="company-info">-->
        <!--          智慧农业终端研发基地配备了先进的研发设备和实验环境，能够满足各种复杂的研发需求。通过不断地探索和实践，研发基地取得了显著的成果。-->
        <!--        </div>-->
        <div class="more-info" @click="aboutUs">
          {{ $t('home.content.info4') }}
        </div>
      </div>
      <div class="company-img">
        <img :src="require('@/assets/aboutUs/banner.jpg')" alt="">
      </div>
    </div>

    <!-- 产品中心 -->
    <div class="product-box">
      <div class="product-all">
        <div>
          <div class="product-center"> {{ $t('home.product.title') }}</div>
          <div class="line"></div>
        </div>
        <div class="look-all" @click="toSeeAll"> {{ $t('home.product.more') }} ></div>
      </div>

      <!-- 轮播 -->
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in productList" :key="index" @click="productPath(item)">
            <img class="product-img" :src="item.img" alt="" mode="aspectFill">
            <div class="product-info">
              <div class="title-style"> {{ $t(`home.product.productList.${index}.title`) }}</div>
              <div class="content-style">{{ $t(`home.product.productList.${index}.content`) }}</div>
              <!-- <div class="detail-box">
                <div class="detail">查看详情</div>
                <img class="detail-img" :src="require('@/assets/home/ckxq.png')" alt="">
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="swiper-button-prev"></div>左箭头。如果放置在swiper外面，需要自定义样式。 -->
        <!-- <div class="swiper-button-next"></div>右箭头。如果放置在swiper外面，需要自定义样式。 -->
      </div>

      <!-- 咨询热线 -->
      <div class="consult-box">
        <div>
          <div class="consult-now"> {{ $t('home.consult.text1') }}</div>
          <div class="consult-resolve"> {{ $t('home.consult.text2') }}</div>
        </div>
        <div class="help-box">
          <div class="helpline"> {{ $t('home.consult.text3') }}</div>
          <div class="helpPhone">19106337398</div>
          <div class="immConsult" @click="toAsk"> {{ $t('home.consult.text4') }}</div>
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <!-- <div class="solution-box">
      <div class="solution-left">
        <div>
          <div class="resolve">解决方案</div>
          <div class="line"></div>
        </div>
        <div class="swiperSolution">
          <div class="swiper-slide" v-for="(item, index) in solutionList" :key="index" @mouseenter="solutionChange(item, index)">
            <div class="solution-iconFont">
              <img class="solution-icon" :src="solutionId == index ? require('@/assets/home/light.png') : require('@/assets/home/nolight.png')" alt="">
              <div :class="solutionId == index ? 'solution-font' : 'solution-other'">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <img class="guide-img" :src="require('@/assets/home/yindao.png')" alt="">
        <div class="solutionInfo">
          {{ itemInfo.content }}
        </div>
        <div class="learn-more" @click="moreSolution">了解更多 ></div>
      </div>

      <div class="solution-right" v-for="(item, index) in itemInfo.imglist" :key="index">
        <img class="item-one" :src="item.img" alt="">
        <div class="item-two">
          <div class="right-img">
            <div class="wisdom">{{ item.name }}</div>
            <div class="english-wisdom">{{ item.englishName }}</div>
          </div>
          <img class="img" :src="item.imgTwo" alt="">
        </div>
      </div>
    </div> -->

    <!-- 企业咨询 -->
    <!-- <div class="company_consult_box">
      <div class="company_consult">
        <div class="company_consult_title">
          <div class="company_consult_name">企业资讯</div>
          <div class="company_consult_all" @click="companyAll">查看全部 ></div>
        </div>
        <div class="company_consult_sg"></div>
        <div class="company_consult_content">
          <div class="company_title">
            <a-carousel autoplay :beforeChange="beforeChange" ref="carousel">
              <div v-if="item.status == 1" class="companyImg_box" @click="toCompanyPath(item, index)"
                v-for="(item, index) in companyList" :key="index">
                <img :src="item.cover" alt="">
                <div class="item_title">{{ item.title }}</div>
              </div>
            </a-carousel>
          </div>
          <div class="company_center">
            <div v-if="item.status == 1" :class="consultId == index ? getLightFlag[index] : getFlag[index]"
              v-for="(item, index) in companyList" @click="toCompanyPath(item, index)" :key="index"
              @mouseenter="changeCompanyList(item, index)">
              <div :style="item.itemStyle">
                <div v-if="index == 0 || index == 1" :class="consultId == index ? 'titleLightStyle' : 'titleStyle'">{{
                  item.title }}</div>
                <div v-else :class="consultId == index ? 'titleLightLast' : 'titleLast'">{{
                  item.title }}</div>
                <div v-if="index == 0 || index == 1" :class="consultId == index ? 'topLight_content' : 'top_content'">{{
                  item.info }}</div>
              </div>

              <div :class="index == 0 || index == 1 ? 'dataStyle' : 'dataStyleLast'">
                <div>
                  <div :class="consultId == index ? 'lightData' : 'data'">{{ formatDayTime(item.createTime) }}</div>
                  <div :class="consultId == index ? 'light_year_month' : 'year_month'">{{ formatYearTime(item.createTime)
                  }}</div>
                </div>
                <div v-if="index == 0 || index == 1" :class="consultId == index ? 'lightStyleImg' : 'right_circle'"></div>
                <div v-else :class="consultId == index ? 'lightStyleImgs' : 'styleImg'"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 领取解决方案 -->
    <div class="receive-solution">
      <div class="free"> {{ $t('home.receive.text1') }}</div>
      <div class="receive-info">{{ $t('home.receive.text2') }}</div>
      <div class="input_style">
        <!-- <input class="input" type="text" v-model="form.orgName" placeholder="请输入公司名称"> -->
        <input class="input" :maxlength="11" type="text" v-model="form.mobile" :placeholder="$t('home.receive.text3')">
        <input class="input" type="text" v-model="form.username" :placeholder="$t('home.receive.text4')">
      </div>
      <div class="imm-consult" @click="submit">{{ $t('home.receive.text5') }}</div>
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { bizConsultInfoAdd } from '@/api/home.js'
import { getBizNewArticlesList } from '@/api/companyConsult.js'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import "swiper/swiper-bundle.min.css"  // 所有 Swiper 样式，包括所有模块样式（如导航、分页等）
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from "swiper"

export default {
  data() {
    return {
      solutionId: 0,
      itemInfo: {},//当前点击的每条数据
      current: ['home'],
      scrollTop: 0, //滚动条距离顶部的高度
      consultId: 0, //企业咨询id
      companyInfo: {},
      form: {
        orgName: '',
        mobile: '',
        username: ''
      },
      getLightFlag: [
        'light1',
        'light2',
        'light3',
        'light4',
        'light5'
      ],
      getFlag: [
        'item1',
        'item2',
        'item3',
        'item4',
        'item5'
      ],
      // 企业咨询
      companyList: [],

      // 解决方案
      solutionList: [
        {
          name: '智慧消防解决方案',
          path: '/solutionFireProtection',
          content: '智慧消防解决方案是基于物联网与人工智能技术，提供消防信息化、智能化管理的综合性解决方案，以提升消防安全水平、保障人员生命财产安全。',
          imglist: [
            {
              img: require('@/assets/home/rectangle.png'),
              imgTwo: require('@/assets/home/rectangleTwo.png'),
              name: "智慧消防解决方案",
              englishName: 'INTELLIGENT FIREFIGHTING SOLUTIONS'
            }
          ],
        },
        {
          name: '智慧养老解决方案',
          path: '/solutionRetirement',
          content: '智慧养老解决方案是利用物联网、人工智能等技术手段，结合一系列智能化设备和服务，为老年人提供智慧养老服务管理的解决方案，以推动养老事业健康、安全、便捷的发展。',
          imglist: [
            {
              img: require('@/assets/home/yl.png'),
              imgTwo: require('@/assets/home/yl2.png'),
              name: "智慧养老解决方案",
              englishName: 'INTELLIGENT RETIREMENT SOLUTIONS'
            }
          ]
        },
        {
          name: '智慧社区解决方案',
          path: '/solutionCommunity',
          content: "智慧社区解决方案是基于物联网和云计算技术，提供一站式智慧社区建设服务，以创造更加安全、智能、高效、便捷的生活环境和服务体验。",
          imglist: [
            {
              img: require('@/assets/home/sq.png'),
              imgTwo: require('@/assets/home/sq2.png'),
              name: "智慧社区解决方案",
              englishName: 'INTELLIGENT COMMUNITY SOLUTIONS'
            }
          ]
        },
        {
          name: '农业灌溉解决方案',
          path: '/irrigationSystem',
          content: "智能阀门控制器是一款高效农业灌溉设备，采用太阳能供电与4G网络连接，无需布线即可远程管理。内置ML307A模块、12V-5000mAh电池和自主研发控制板，支持双路阀门控制和外接流量计。可扩展多种传感器，兼容智慧农业平台，实现精准灌溉和数据分析。",
          imglist: [
            {
              img: require('@/assets/home/gg1.png'),
              imgTwo: require('@/assets/home/gg2.png'),
              name: "农业灌溉解决方案",
              englishName: 'AGRICULTURAL IRRIGATION SOLUTIONS'
            }
          ]
        },
        // {
        //   name: '99元建站解决方案',
        //   path: '/companyWeb',
        //   content: "99 元建站，实惠之选！轻松搭建企业网站，展示企业形象，提升品牌知名度，拓展线上业务。简单便捷，性价比高，助力企业发展。",
        //   imglist: [
        //     {
        //       img: require('@/assets/home/991.png'),
        //       imgTwo: require('@/assets/home/992.png'),
        //       name: "99元建站解决方案",
        //       englishName: '99 YUAN WEBSITE CONSTRUCTION SOLUTION'
        //     }
        //   ]
        // },
      ],

      // 头部轮播
      headList: [
        {
          img: require('@/assets/home/lunbo-1.jpg'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-2.png'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-3.jpg'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-4.jpg'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-6.jpg'),
          path: ''
        },
        // {
        //   img: require('@/assets/home/robot.png'),
        //   path: '/transportRobot'
        // },
        // {
        //   img: require('@/assets/home/fm.png'),
        //   path: '/irrigationSystem'
        // },
        // {
        //   img: require('@/assets/home/group.png'),
        //   path: '/solution'
        // },
        // {
        //   img: require('@/assets/home/baner1.png'),
        //   path: '/storeYard'
        // },
        // {
        //   img: require('@/assets/home/baner3.png'),
        //   path: '/solutionRetirement'
        // },
      ],
      headList1: [
        {
          img: require('@/assets/home/lunbo-10.png'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-20.png'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-30.png'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-40.png'),
          path: ''
        },
        {
          img: require('@/assets/home/lunbo-60.png'),
          path: ''
        },
      ],

      productList: [
        {
          title: '石塑箱',
          content: "石塑箱具备多重优势:防水防潮、抗压耐摔、耐-30°C至 80°C温差，防护性强;可循环使用数十次，折叠后省空间，轻量化设计降本增效;有密封防尘、食品级安全等功能，支持标识定制与自动化适配。适用于多场景，是绿色高效的物流包装优选。",
          img: require('@/assets/home/ccc.png'),
          path: '/weedingRobot'
        },
        {
          title: '石塑建材',
          content: "石塑建材具备多重优势:高强度且轻质抗冲击、耐腐蚀，耐久性远超传统材料;导热导电性能优异，可用于节能地暖、智能温控等场景;具有抗菌抑菌特性，适配医疗、食品等高卫生需求环境;绿色环保，材料无毒可回收，且能提升建筑保温隔热效果，降低能耗，助力实现低碳建筑与智能化集成。",
          img: require('@/assets/home/roote1.jpg'),
          path: '/transportRobot'
        },
        // {
        //   title: '太阳能阀门智能热水器',
        //   content: "太阳能阀门智能控制器可以做到远程用水量控制，有效减少人工依赖，并具有预警设置和太阳能供电等功能，真正做到了智能控制，节能无忧，让灌溉更加便捷。",
        //   img: require('@/assets/home/fmm1.png'),
        //   path: '/irrigationSystem'
        // },
        // {
        //   title: '智慧消防',
        //   content: "实现消防的智能化，提高信息传递的效率、保障消防设施的完好率、增强员工消防安全意识、降低火灾发生及损失。",
        //   img: require('@/assets/home/zhxf.png'),
        //   path: '/fireProtection'
        // },
        // {
        //   title: '智慧社区',
        //   content: "基于物联网、人工智能和大数据等技术手段，以提升社区生活质量和服务水平，推动社区可持续发展的智能化社区。",
        //   img: require('@/assets/home/zhsq.png'),
        //   path: '/community'
        // },
        // {
        //   title: '智慧养老',
        //   content: "通过智能化技术和服务，为老年人提供更优质、安全、健康、便捷、舒适的生活方式和养老服务的一种养老模式。",
        //   img: require('@/assets/home/zhyl.png'),
        //   path: '/retirement'
        // },
        // {
        //   title: '智慧农业',
        //   content: "打造智慧农业大脑和应用服务体系，实现农情监测实时化、农业生产智能化、农产品监管科学化、农业经营网络化、农业服务精准化企业名片：呈现企业信息和品牌形象，方便快捷地分享和传递，同时提升企业形象和业务合作的便利性。",
        //   img: require('@/assets/home/zhny.png'),
        //   path: '/agriculture'
        // },
        // {
        //   title: '企业名片',
        //   content: "呈现企业信息和品牌形象，方便快捷地分享和传递，同时提升企业形象和业务合作的便利性。",
        //   img: require('@/assets/home/zhmp.png'),
        //   path: '/businessCard'
        // },
        // {
        //   title: '放心消费一码通',
        //   content: "集多种生活服务于一体的数字化生活平台，让消费者轻松便捷地享受更多优惠与服务。",
        //   img: require('@/assets/home/ydym.png'),
        //   path: '/storeYard'
        // },
        // {
        //   title: '分销商城',
        //   content: "在线销售、营销、推广及物流等服务为主要特色的电子商务模式，让分销商通过推广商品获取佣金提成，从而实现共赢互利。",
        //   img: require('@/assets/home/fxsc.png'),
        //   path: '/distributionMall'
        // },
        // {
        //   title: 'APP小程序定制开发',
        //   content: "产品经理一对一沟通，定制化服务，满足你的个性化需求",
        //   img: require('@/assets/home/app.jpg'),
        //   path: '/customization'
        // },
        // {
        //   title: '系统定制',
        //   content: "量身定制，源码交付，无忧运维支持全方位协同操作与后台管控个性化系统平台、CRM、CMS、OA、ERP、HIS、MES等企业系统定制解决方案",
        //   img: require('@/assets/home/xtdz.jpg'),
        //   path: '/systemCustomization'
        // }
      ]
    }
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll)

    // 产品中心轮播
    new Swiper(".swiper", {
      speed: 400,
      spaceBetween: 45,
      slidesPerView: 3,
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,//1秒切换一次
        pauseOnMouseEnter: true,
      },
      modules: [Navigation, Pagination, Scrollbar, Autoplay],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // scrollbar: {
      //   el: ".swiper-scrollbar",
      //   draggable: true,
      // },
    })

    // 头部轮播
    // 产品中心轮播
    new Swiper(".swiperHeader", {
      speed: 400,
      // spaceBetween: 100,
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,//1秒切换一次
        pauseOnMouseEnter: true,
      },
      modules: [Navigation, Pagination, Scrollbar, Autoplay],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    })
  },
  created() {
    this.itemInfo = this.solutionList[0]
    this._getBizNewArticlesList()
  },

  methods: {
    // 认领提交
    submit() {
      let ref = /^1[3456789]\d{9}$/
      if (!ref.test(this.form.mobile)) {
        this.$message.warning('请输入正确的手机号格式！')
        return
      }
      // if (!this.form.orgName) {
      //   this.$message.warning('请输入公司名称')
      //   return
      // } else
      if (!this.form.mobile) {
        this.$message.warning('请输入联系电话')
        return
      } else if (!this.form.username) {
        this.$message.warning('请输入姓名')
        return
      }
      bizConsultInfoAdd(this.form).then(res => {
        if (res.data.success) {
          this.$message.success('信息已提交，请耐心等待~')
        }
      })
    },

    formatDayTime(val) {
      if (val) {
        let time = val.split(' ')[0].toString().split('-')[2]
        return time
      }
    },

    formatYearTime(val) {
      if (val) {
        let year = val.split(' ')[0].toString().split('-')[0] + '.' + val.split(' ')[0].toString().split('-')[1]
        return year
      }
    },

    // 获取新闻文章
    _getBizNewArticlesList() {
      let params = {
        column: 'createTime',
        order: 'desc',
        pageNo: 1,
        pageSize: 10
      }
      getBizNewArticlesList(params).then(res => {
        let result = res.result.records.filter(item => item.status == 1)
        this.companyList = result.slice(0, 5)
      })
    },

    // 企业资讯全部跳转
    companyAll() {
      this.$router.push({
        path: "/companyConsult"
      }, () => {
      })
    },

    // 企业资讯轮播
    beforeChange(from, to) {
      this.consultId = to
    },

    // 企业资讯
    changeCompanyList(item, index) {
      if (this.consultId == index) return
      this.consultId = index
      this.$refs.carousel.goTo(index)
    },

    // 资讯跳转
    toCompanyPath(item, index) {
      this.consultId = index
      this.$refs.carousel.goTo(index)
      this.$router.push({
        path: '/companyConsultDetail?id=' + item.id
      })
    },

    toPath(item) {
      if (!item.path) return
      this.$router.push({
        path: item.path
      })
    },

    // 查看产品
    toSeeAll() {
      this.$router.push({ path: "/product" })
    },
    // 解决方案跳转路径
    moreSolution() {
      this.$router.push({
        path: this.itemInfo.path
      })
    },

    // 产品模块跳转
    productPath(item) {
      this.$router.push({
        path: item.path
      })
    },

    // 关于我们跳转
    aboutUs() {
      this.$router.push({
        path: '/aboutUs'
      })
    },

    // 解决方案
    solutionChange(item, index) {
      if (this.solutionId == index) return

      this.solutionId = index
      this.itemInfo = item
    },

    handleScroll() {
      let top = Math.floor(
        document.documentElement.scrollTop || document.body.scrollTop
      )
      this.scrollTop = top
    },
  },

  components: {
    Header,
    Footer,
  }
}
</script>

<style lang="less">
.home-box {
  width: 100%;
  position: relative;
  overflow-x: hidden;

  .swiperHeader {
    width: 100%;
    position: relative;
    --swiper-pagination-color: #fff;

    .swiper-button-prev {
      color: rgba(255, 255, 255, 0.6);
      top: var(--swiper-navigation-top-offset, 48%);
    }

    .swiper-button-next {
      color: rgba(255, 255, 255, 0.6);
      top: var(--swiper-navigation-top-offset, 48%);
    }

    .swiper-pagination-fraction {
      top: var(--swiper-pagination-top, 96%);
    }

    .swiper-slide {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;

      img {
        width: 100%;
        height: 100vh;
        //object-fit: cover;
      }
    }
  }

  .line {
    width: 64px;
    height: 4px;
    background: #3961f4;
    margin: 16px 0;
  }

  .home-content {
    width: 1440px;
    // height: 800px;
    padding: 191px 0;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    .company-sg {
      width: 800px;

      .sg-style {
        font-size: 56px;
        font-weight: 400;
        color: #1d2129;
      }

      .company-brief {
        font-size: 20px;
        font-weight: 400;
        color: #1d2129;
      }

      .company-info {
        font-size: 20px;
        font-weight: 400;
        color: #4e5969;
        margin: 8px 0 16px 0;
        text-indent: 2em;
      }

      .more-info {
        display: inline-block;
        // width: 125px;
        margin-top: 10px;
        background: #3961f4;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        padding: 7px 20px;
        cursor: pointer;
      }
    }

    .company-img {
      width: 510px;
      height: 400px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .product-box {
    width: 100%;
    background: #f7faff;
    padding: 160px 0;

    .product-all {
      width: 1440px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;

      .product-center {
        font-size: 56px;
        font-weight: 400;
        color: #1d2129;
      }

      .look-all {
        background: linear-gradient(135deg, #52a4ff 0%, #4b7bfc 100%);
        padding: 10px 24px;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .swiper {
      width: 1440px;

      .swiper-button-prev {
        color: #fff;
      }

      .swiper-button-next {
        color: #fff;
        right: var(--swiper-navigation-top-offset, 2%);
      }

      .swiper-slide {
        //height: auto;
        // width: 305px;
        //height: 200px;
        width: 450px !important;
        margin-right: 45px !important;
        margin-top: 60px;
        cursor: pointer;
        overflow: hidden;

        &:hover {
          .product-img {
            overflow: hidden;
            border: none;
            transform: scale(1.1);
          }

          .product-info>.title-style,
          .content-style {
            font-weight: 600;
          }
        }
      }

      .product-img {
        width: 100%;
        //height: auto;
        height: 300px;
        border: 1px solid #e6e6e6;
        border-radius: 10px;
        // width: 345px;
        // height: 240px;
        transition: all 1s;
        overflow: hidden;
      }

      .product-info {
        background: #fff;
        padding: 20px;
        // width: 345px;
        width: 100%;
        height: 100%;

        .title-style {
          font-size: 20px;
          font-weight: 400;
          color: #1d2129;
          // &:hover{
          //   font-weight: 600;
          // }
        }

        .content-style {
          font-size: 16px;
          font-weight: 400;
          color: #86909c;
          margin: 8px 0 10px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          // max-height: 58px;
        }

        .detail-box {
          display: flex;
          align-items: center;
          cursor: pointer;

          .detail {
            font-size: 14px;
            font-weight: 400;
            color: #3961f4;
          }

          .detail-img {
            width: 16px;
            height: 16px;
            margin-left: 10px;
          }
        }
      }
    }

    .consult-box {
      width: 1440px;
      height: 280px;
      background: url("~@/assets/home/zxrx.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin: 156px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 82px;

      .consult-now {
        font-size: 48px;
        font-weight: 400;
        color: #ffffff;
      }

      .consult-resolve {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 20px;
      }

      .help-box {
        display: flex;
        flex-direction: column;
        align-items: end;

        .helpline {
          font-size: 36px;
          font-weight: 400;
          color: #ffffff;
        }

        .helpPhone {
          font-size: 56px;
          font-weight: 500;
          margin: 10px 0;
          color: #ffffff;
        }

        .immConsult {
          display: inline-block;
          // width: 139px;
          border-radius: 8px;
          border: 1px solid #ffffff;
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 35px;
          cursor: pointer;
        }
      }
    }
  }

  .solution-box {
    width: 1440px;
    // height: 1026px;
    padding: 128px 0;
    background: #fff;
    display: flex;
    align-items: center;
    margin: 0 auto;

    .solution-left {
      width: 601px;
      // margin: 160px 240px 0 0;
      padding: 0 240px 0 0;
      flex: 0 0 auto;

      .resolve {
        font-size: 56px;
        font-weight: 400;
        color: #1d2129;
      }

      .solution-iconFont {
        display: flex;
        align-items: center;
        margin-top: 20px;

        .solution-icon {
          width: 16px;
          height: 16px;
        }

        .solution-font {
          font-size: 24px;
          font-weight: 400;
          color: #3961f4;
          padding-left: 24px;
          cursor: pointer;
        }

        .solution-other {
          font-size: 24px;
          font-weight: 400;
          color: #86909c;
          padding-left: 24px;
          cursor: pointer;
        }
      }

      .guide-img {
        width: 56px;
        height: 56px;
        margin: 20px 0;
      }

      .solutionInfo {
        font-size: 20px;
        font-weight: 400;
        color: #1d2129;
        overflow: hidden; //超出隐藏
        text-overflow: ellipsis; //溢出显示省略号
        white-space: normal; //常规默认，会折行
        display: -webkit-box;
        -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
        -webkit-line-clamp: 3;
      }

      .learn-more {
        font-size: 20px;
        font-weight: 400;
        color: #4d85fd;
        line-height: 28px;
        margin-top: 40px;
        cursor: pointer;
      }
    }

    .solution-right {
      // margin: 128px 0 0 118px;
      width: 100%;
      padding: 0 0 0 118px;

      .item-one {
        width: 100%;
      }

      .item-two {
        display: flex;
        justify-content: end;

        .right-img {
          width: 308px;
          height: 440px;
          background: #4278f1;
          background-image: url("~@/assets/home/zu.png");

          .wisdom {
            font-size: 32px;
            font-weight: 500;
            color: #ffffff;
            padding: 71px 0 27px 0;
            text-align: center;
          }

          .english-wisdom {
            font-size: 24px;
            font-weight: 500;
            color: #cfd9fc;
            padding: 0 28px;
          }
        }

        .img {
          width: 310px;
          height: 310px;
        }
      }
    }
  }

  .company_consult_box {
    width: 100%;
    background-color: #f7faff;

    .company_consult {
      width: 1440px;
      margin: 0 auto;
      padding: 160px 0;

      .company_consult_title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .company_consult_name {
          font-size: 56px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #1d2129;
        }

        .company_consult_all {
          width: 156px;
          padding: 10px 24px;
          font-size: 20px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          background: linear-gradient(135deg, #52a4ff 0%, #4b7bfc 100%);
          text-align: center;
          cursor: pointer;
        }
      }

      .company_consult_sg {
        width: 64px;
        height: 4px;
        background: #3961f4;
        margin-top: 24px;
      }

      .company_consult_content {
        width: 100%;
        margin-top: 84px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .company_title {
          width: 640px;
          height: 524px;

          .companyImg_box {
            width: 640px;
            height: 524px;
            position: relative;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            .item_title {
              width: 640px;
              padding: 20px;
              background: rgba(0, 0, 0, 0.8);
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ffffff;
              position: absolute;
              bottom: 0;
            }
          }
        }

        .company_center {
          width: 767px;
          height: 523px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          justify-content: space-between;

          .item1,
          .item2 {
            width: 372px;
            height: 250px;
            background: #fff;
            padding: 21px 36px 21px 31px;
            cursor: pointer;
          }

          .light1,
          .light2 {
            width: 372px;
            height: 250px;
            background: #4c7cfd;
            padding: 21px 36px 21px 31px;
            cursor: pointer;
          }

          .titleStyle {
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #1d2129;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .titleLightStyle {
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: #fff;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .titleLightLast {
            width: 200px;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 600;
            color: #fff;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .titleLast {
            width: 200px;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #1d2129;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .item3,
          .item4,
          .item5 {
            width: 372px;
            height: 158px;
            background: #ffffff;
            padding: 21px 36px 21px 31px;
            display: flex;
            flex-direction: row-reverse;
            cursor: pointer;
          }

          .light3,
          .light4,
          .light5 {
            width: 372px;
            height: 158px;
            background: #4c7cfd;
            padding: 21px 36px 21px 31px;
            display: flex;
            flex-direction: row-reverse;
            cursor: pointer;
          }

          .top_content {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #4e5969;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            margin-top: 10px;
          }

          .topLight_content {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            margin-top: 10px;
          }

          .data {
            font-size: 36px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #86909c;
          }

          .lightData {
            font-size: 36px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
          }

          .year_month {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #86909c;
          }

          .light_year_month {
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }

          .dataStyle {
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 5px;
          }

          .dataStyleLast {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
          }

          .right_circle {
            width: 40px;
            height: 40px;
            background-image: url("@/assets/home/commonRight-circle.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }

          .lightStyleImg {
            width: 40px;
            height: 40px;
            background-image: url("@/assets/home/lightRight-circle.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }

          .styleImg {
            width: 27px;
            height: 27px;
            background-image: url("@/assets/home/arrow-right.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            left: 28px;
            top: 90px;
          }

          .lightStyleImgs {
            width: 27px;
            height: 27px;
            background-image: url("@/assets/home/lightArrow-right.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            position: relative;
            left: 28px;
            top: 90px;
          }
        }
      }
    }
  }

  .ant-carousel .slick-dots {
    width: 150px;
    display: block;
    position: absolute;
    right: 0;
    bottom: 34px;
  }

  .receive-solution {
    width: 100%;
    height: 533px;
    background-image: url("~@/assets/home/ht.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .free {
      font-size: 56px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #1d2129;
    }

    .receive-info {
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #c9cdd4;
      margin: 30px 0;
    }

    .input_style {
      width: 1440px;
      font-size: 20px;

      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .input {
        width: 433px;
        border-top: none;
        border-left: none;
        border-right: none;
        height: 49px;
        border-bottom: 1px solid #cccfd6;
        background: transparent;
        outline-style: none;
      }
    }

    .imm-consult {
      width: 200px;
      // height: 50px;
      border-radius: 8px;
      border: 1px solid #0058ff;
      font-size: 16px;
      font-weight: 400;
      color: #005cff;
      padding: 12px;
      cursor: pointer;
      text-align: center;
      margin-top: 50px;
    }
  }
}
</style>
